// src/axiosInstance.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

/* global 401 handler */
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const { response, config } = err;
    if (response?.status === 401 && !config.url.includes('/auth/me')) {
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
